$(document).ready( function() {
       $(document).foundation().ready(function() {
          var OffCanvas = new Foundation.OffCanvas($('#off-canvas'), {
          open_method : 'overlap' ,
          close_on_click : true
         });
      })
   });
 $(document).ready(function(){

	$(".scrollMove").click(function() {

		position = $( ".projets" ).scrollTop() - $( ".projets" ).find('.project').height();	
		if($(this).attr('data-direction') == 'next'){
			position = $( ".projets" ).scrollTop() + $( ".projets" ).find('.project').height();	
		}

		if(position < 0){
			position = 0; 
		}
		if(position > $( ".projets" ).height()){
			//position = $( ".projets" ).height();
		}

	    $('.projets').animate({
	        scrollTop: position
	    }, 500);

	});


    var $slider = $(".slideshow");

    $slider.slick({ 
            infinite: true,
            centerMode: true, 
            centerPadding: '20%',
            slidesToShow:1,
            slidesToScroll: 1,
            responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    centerPadding: '0px',
                    centerMode: true, 
                }
            }]
        });

    var $sliderDiapo = $(".diaporama"); 

        $sliderDiapo.slick({ 
          lazyLoad: 'ondemand',
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 2,
          responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }]
        });

    var $sliderComments = $("#comments-slide"); 

        $sliderComments.slick({ 
          slidesToShow: 1,
          infinite: true,
          slidesToScroll: 1,
          responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false
                }
            }]
        });


    $('#select_country').on('change',function(){
    	/*document.cookie = "country="+ $(this).val() +";";
        console.log('change country');
    	window.location.reload();*/
        $('#form_search_tax').submit();
    }); 

    $('#select_owner').on('change',function(){
    	/*document.cookie = "owner="+ $(this).val() +";";
        console.log('change owner');
    	window.location.reload();*/
        $('#form_search_tax').submit();
    });

    if($('#select_country').length){
    	$('#select_country').val(select_country);
    }
    if($('#select_owner').length){
    	$('#select_owner').val(select_owner);
    }


});

/*
 function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}*/